import React, { useEffect, useState } from 'react';

const TeamName = ({ name, logo, className = '', size = 'md' }) => {
  const [showLogo, setShowLogo] = useState(Boolean(logo));
  const logoClass = size === 'sm' ? 'h-5 w-5' : 'h-6 w-6';
  const gapClass = size === 'sm' ? 'gap-1.5' : 'gap-2';

  useEffect(() => {
    setShowLogo(Boolean(logo));
  }, [logo]);

  return (
    <span className={`inline-flex items-center ${gapClass} min-w-0 ${className}`}>
      {logo && showLogo ? (
        <img
          src={logo}
          alt=""
          className={`${logoClass} flex-shrink-0 object-contain`}
          onError={() => setShowLogo(false)}
        />
      ) : null}
      <span className="truncate">{name}</span>
    </span>
  );
};

export default TeamName;
